import { COLOR_GREEN_600, COLOR_GREEN_700 } from '@alltrails/denali/tokens';
import { createParkPinSvg } from './svgMarkerComponents';

const defaultParkPinSvg = createParkPinSvg('default-park-pin', COLOR_GREEN_600);
const activeDefaultParkPinSvg = createParkPinSvg('active-default-park-pin', COLOR_GREEN_700);
export { defaultParkPinSvg, activeDefaultParkPinSvg };
